module.exports = {"610112001":"张家堡街道","610112002":"三桥街道","610112003":"辛家庙街道","610112004":"徐家湾街道","610112005":"大明宫街道","610112006":"谭家街道","610112007":"草滩街道","610112008":"六村堡街道","610112009":"未央宫街道","610112010":"汉城街道","610112011":"未央湖街道","610112012":"建章路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610112.json
// module id = 2916
// module chunks = 0